import PropTypes from 'prop-types'
import React from 'react'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import ButtonScrollDown from 'components/ButtonScrollDown'
import { MenuMainContext } from 'contexts/MenuMain'
import Image from 'styles/components/Image'
import { Text, H1Small as H1 } from 'styles/components/typography'

import bacteria from './assets/bacteria_catcher.svg'

const BNutritionFirstBlock = ({ data, scrollToElement }) => {
  const { isSalesBanner, salesBannerHeight } = React.useContext(MenuMainContext)
  return (
    <FirstBlockWrapper
      isExtraTopIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
      className="bg--gray--op-06 pb-2 pb-md-4"
    >
      <div className="row">
        <div className="col-md-5 col-lg-4 align-self-center">
          <Image
            className="mt-3 mt-md-6 mx-auto"
            src={bacteria}
            alt="bacteria catcher"
            maxWidth={280}
          />
        </div>
        <div className="col-md-7 col-lg-7 offset-lg-1">
          <H1
            className="mt-md-3 mt-lg-4"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <Text
            className="mb-4"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ButtonScrollDown
            title={data.go_to_site}
            refToScroll={scrollToElement}
          />
        </div>
      </div>
    </FirstBlockWrapper>
  )
}

BNutritionFirstBlock.propTypes = {
  data: PropTypes.object.isRequired,
  scrollToElement: PropTypes.object,
}

BNutritionFirstBlock.defaultProps = {
  scrollToElement: null,
}

export default BNutritionFirstBlock
